<template>
  <component :is="getBannerContainerComponent(props.item.link_type)" v-bind="getBannerContainerProps(item)">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { type CategoryBanner, type RegionBanner, EdbBannerLinkType } from '@/types/api'

interface Props {
  item: CategoryBanner | RegionBanner
}

const props = defineProps<Props>()

function getBannerContainerComponent(type?: EdbBannerLinkType) {
  switch (type) {
    case EdbBannerLinkType.BannerLinkTypeURL:
      return 'a'
    default:
      return 'div'
  }
}

function getBannerContainerProps(item?: CategoryBanner) {
  switch (item?.link_type) {
    case EdbBannerLinkType.BannerLinkTypeURL:
      return { href: item.link_target, target: '_blank', rel: 'noopener noreferrer' }
    default:
      return {}
  }
}
</script>
